import {ReportVehicleDetails} from './report-item-details.model';

export class ReportRequest {
  constructor(
    public readonly excelExportColumns: string[] = [],
    public readonly excelItemSearchDto: ReportVehicleDetails = new ReportVehicleDetails()
  ) {
  }
}
